export const username="gmedochb-dev-sbx";
export const password="9zQnA7BK9NmH";
export const url='https://snowplow-otel-receiver-sbx-http.bpweb.bp.com:443';
export const bp_product_id='gmedochub-dev';
export const cookieName="user_id";
export const deviceName="install_id";
//export const otel_auth="acs";
export const env="sbx";
/*https://snowplow-otel-receiver-http.bpweb.bp.com:443*/
/*snowplow-otel-receiver-sbx-http.bpweb.bp.com:443*/